import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=967802fe&scoped=true"
import script from "./fileDetail.vue?vue&type=script&lang=js"
export * from "./fileDetail.vue?vue&type=script&lang=js"
import style0 from "./fileDetail.vue?vue&type=style&index=0&id=967802fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967802fe",
  null
  
)

export default component.exports